(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8876],{

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 54073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(29259),
    now = __webpack_require__(61100),
    toNumber = __webpack_require__(7642);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 61100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(37772);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 83336:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/additional-order",
      function () {
        return __webpack_require__(49988);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 16718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ spinner; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/components/atom/spinner/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 200;\n    stroke-dashoffset: -35px;\n  }\n  100% {\n    stroke-dashoffset: -124px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  vertical-align: middle;\n  transform-origin: center;\n  animation: ",
        " 2s linear infinite;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fill: none;\n  stroke: ",
        ";\n  stroke-dasharray: 1, 200;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  animation: ",
        " calc(2s * 0.75) ease-in-out infinite;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Rotate = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var Stretch = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var SpinnerContainer = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
    componentId: "sc-87510cb7-0"
})(_templateObject2(), function(param) {
    var _size = param.size, size = _size === void 0 ? 28 : _size;
    return {
        width: "".concat(size, "px"),
        height: "".concat(size, "px")
    };
}, Rotate);
var SpinnerCircle = styled_components_browser_esm/* default.circle.withConfig */.ZP.circle.withConfig({
    componentId: "sc-87510cb7-1"
})(_templateObject3(), function(param) {
    var _color = param.color, color = _color === void 0 ? theme/* default.color.white */.Z.color.white : _color;
    return color;
}, Stretch);

;// CONCATENATED MODULE: ./src/components/atom/spinner/index.tsx
/* Ref. https://github.com/GriffinJohnston/uiball-loaders/blob/main/src/components/Ring.js */ 

var Spinner = function(param) {
    var color = param.color, size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinnerContainer, {
        viewBox: "25 25 50 50",
        strokeWidth: "5",
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpinnerCircle, {
            cx: "50",
            cy: "50",
            r: "20",
            color: color
        })
    });
};
/* harmony default export */ var spinner = (Spinner);


/***/ }),

/***/ 39219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ infinite_scroll; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/common/infinite-scroll/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  //overflow-y: scroll;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var InfiniteScrollContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-d3f94304-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/components/molecules/loader/index.tsx + 1 modules
var molecules_loader = __webpack_require__(8366);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.tsx
var useIntersectionObserver = __webpack_require__(13041);
;// CONCATENATED MODULE: ./src/components/common/infinite-scroll/index.tsx





var InfiniteScroll = function(param) {
    var _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, rootMargin = param.rootMargin, children = param.children, _loader = param.loader, loader = _loader === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_loader/* default */.Z, {}) : _loader, isLoading = param.isLoading, hasNextPage = param.hasNextPage, fetchNextPage = param.fetchNextPage;
    var ref = (0,react.useState)(), loaderElement = ref[0], setLoaderElement = ref[1];
    var entry = (0,useIntersectionObserver/* default */.Z)({
        target: loaderElement,
        threshold: threshold,
        rootMargin: rootMargin
    });
    (0,react.useEffect)(function() {
        if ((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && hasNextPage && !isLoading) {
            fetchNextPage();
        }
    }, [
        entry,
        hasNextPage,
        isLoading,
        fetchNextPage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfiniteScrollContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: children
            }),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: function(ref) {
                    return setLoaderElement(ref);
                },
                children: isLoading && loader
            })
        ]
    });
};
/* harmony default export */ var infinite_scroll = (InfiniteScroll);


/***/ }),

/***/ 8366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ loader; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/atom/spinner/index.tsx + 1 modules
var spinner = __webpack_require__(16718);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/molecules/loader/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 10px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LoaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-59f274fe-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/molecules/loader/index.tsx



var Loader = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {
            size: props.size,
            color: props.color
        })
    });
};
/* harmony default export */ var loader = (Loader);


/***/ }),

/***/ 36746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89961);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  padding: 8px 0 6px;\n  z-index: 1;\n  white-space: nowrap;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 4px 8px;\n  border-radius: 8px;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var DNSlideTabItem = function(_param) {
    var label = _param.label, isActive = _param.isActive, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "label",
        "isActive"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTabItem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        className: isActive ? "DNSlideTabItem_selected" : "DNSlideTabItem",
        isActive: isActive,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
            isActive: isActive,
            children: label
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (DNSlideTabItem);
var StyledTabItem = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-b5de5b68-0"
})(_templateObject(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return "\n    border-bottom: 2px solid ".concat(isActive ? "".concat(theme.color.gray800) : "transparent", "\n  ");
});
var Label = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-b5de5b68-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return "\n    ".concat(isActive ? theme.typography.UI15SB : theme.typography.UI15M, ";\n    color: ").concat(isActive ? theme.color.gray800 : theme.color.gray400, ";\n\n    &: active {\n      background: ").concat(theme.color.gray50, ";\n    }\n  ");
});


/***/ }),

/***/ 25785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89961);
/* harmony import */ var _design_components_organisms_dnslide_tab_dnslide_tab_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36746);
/* harmony import */ var _utils_style__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76666);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  overflow-x: auto;\n  padding: 0 24px;\n  gap: 12px;\n\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var DNSlideTab = function(_param) {
    var value = _param.value, _group = _param.group, group = _group === void 0 ? false : _group, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "value",
        "group",
        "children"
    ]);
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!value) return;
        if (!scrollRef.current) return;
        var children = Array.from(scrollRef.current.children);
        children.forEach(function(child) {
            if (child.classList.contains("DNSlideTabItem_selected")) {
                var ref = child.getBoundingClientRect(), left = ref.left, width = ref.width;
                var innerWidth = window.innerWidth;
                if (left + width / 2 !== innerWidth / 2) {
                    var ref1, ref2;
                    (ref1 = scrollRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollTo({
                        top: 0,
                        left: ((ref2 = scrollRef.current) === null || ref2 === void 0 ? void 0 : ref2.scrollLeft) + (left - innerWidth / 2 + width / 2),
                        behavior: "smooth"
                    });
                }
            }
        });
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,_utils_style__WEBPACK_IMPORTED_MODULE_5__.cn)([
            "relative",
            props.className
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
                ref: scrollRef,
                group: group,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BorderBottom, {})
        ]
    });
};
DNSlideTab.Item = _design_components_organisms_dnslide_tab_dnslide_tab_item__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;
/* harmony default export */ __webpack_exports__["Z"] = (DNSlideTab);
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8df1a353-0"
})(_templateObject(), function(param) {
    var group = param.group;
    return "\n    ".concat(group ? "\n          button {\n            flex: 1;\n            span {\n              width: 100%;\n            }\n          }" : "", ";\n  ");
});
var BorderBottom = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8df1a353-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    border-bottom: 1px solid ".concat(theme.color.gray100, ";\n  ");
});


/***/ }),

/***/ 13041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87394);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var useIntersectionObserver = function(param) {
    var target = param.target, _freeze = param.freeze, freeze = _freeze === void 0 ? false : _freeze, _threshold = param.threshold, threshold = _threshold === void 0 ? 0 : _threshold, _root = param.root, root = _root === void 0 ? null : _root, _rootMargin = param.rootMargin, rootMargin = _rootMargin === void 0 ? "0%" : _rootMargin;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), entry = ref[0], setEntry = ref[1];
    var observer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var updateEntry = function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), currentEntry = _param[0];
        setEntry(currentEntry);
    };
    var cleanObserver = function() {
        if (observer.current) {
            observer.current.disconnect();
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var hasIOSupport = "IntersectionObserver" in window;
        if (!freeze && target && hasIOSupport) {
            var observerParams = {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            };
            var observer = new IntersectionObserver(updateEntry, observerParams);
            observer.observe(target);
        }
        return function() {
            cleanObserver();
        };
    }, [
        target,
        root,
        rootMargin,
        threshold,
        freeze
    ]);
    return entry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersectionObserver);


/***/ }),

/***/ 49988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_additional_order; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ./src/components/layouts/TemplateLayout.tsx
var TemplateLayout = __webpack_require__(75275);
// EXTERNAL MODULE: ./src/components/molecules/sticky-app-header/index.tsx + 3 modules
var sticky_app_header = __webpack_require__(83025);
// EXTERNAL MODULE: ./src/design-components/organisms/dnslide-tab/index.tsx
var dnslide_tab = __webpack_require__(25785);
// EXTERNAL MODULE: ../../libs/ui/dist/index.es.js
var index_es = __webpack_require__(59950);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
;// CONCATENATED MODULE: ./src/constants/logs/order/index.ts
var ORDER_LOG_EVENT = {
    CLICKED_ADDITIONAL_ORDER_CATEGORIES: "clicked_additional_order_categories",
    CLICKED_SKIP_ADDITIONAL_ORDER: "clicked_additional_order_skip_button",
    EXITED_ADDITIONAL_ORDER_PAGE: "exited_additional_order_page",
    IMPRESSED_ADDITIONAL_ORDER_PRODUCT: "impressed_additional_order_product",
    CLICKED_ADDITIONAL_ORDER_CATEGORY_TAB: "clicked_additional_order_category_tab",
    CLICKED_ADDITIONAL_ORDER_ADD_TO_CART: "clicked_additional_order_add_cart",
    CLICKED_ADDITIONAL_ORDER_REMOVE_FROM_CART: "clicked_additional_order_remove_cart",
    CLICKED_SUBMIT_ADDITIONAL_ORDER: "clicked_additional_order_submit_button"
};

// EXTERNAL MODULE: ./src/entities/additional-order/index.ts + 6 modules
var additional_order = __webpack_require__(97298);
// EXTERNAL MODULE: ./src/entities/order/index.ts + 2 modules
var order = __webpack_require__(36084);
// EXTERNAL MODULE: ./src/hooks/useLogger.ts
var useLogger = __webpack_require__(8202);
// EXTERNAL MODULE: ./src/hooks/useModal.tsx
var useModal = __webpack_require__(98266);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/types/modal.ts
var modal = __webpack_require__(74701);
// EXTERNAL MODULE: ./src/types/pharmacy.ts
var pharmacy = __webpack_require__(6271);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/utils/mobile/postMessageEventList.messages.ts + 2 modules
var postMessageEventList_messages = __webpack_require__(48974);
// EXTERNAL MODULE: ./src/utils/report.ts + 289 modules
var report = __webpack_require__(80162);
// EXTERNAL MODULE: ../../node_modules/lodash/debounce.js
var debounce = __webpack_require__(54073);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/views/additional-order/hooks/AdditionalOrderViewModel.ts




















var DEBOUNCE_TIME = 1500;
var MAX_ADD_PRODUCT_QUANTITY = 10;
var useAdditionalOrderViewModel = function() {
    var router = (0,next_router.useRouter)();
    var log = (0,useLogger/* default */.Z)().log;
    var navigate = (0,useNavigate/* default */.Z)();
    var showModal = (0,useModal/* default */.Z)().showModal;
    var _query = router.query, prescriptionSendType = _query.prescriptionSendType, pharmacyId = _query.pharmacyId, diagnosisId = _query.diagnosisId, amountToPay = _query.amountToPay, mainTagTypes = _query.mainTagTypes, _isUserAlternativeSelected = _query.isUserAlternativeSelected, isUserAlternativeSelected = _isUserAlternativeSelected === void 0 ? null : _isUserAlternativeSelected, medicineRequestInfos = _query.medicineRequestInfos;
    var ref = (0,react.useState)(null), selectedCategoryId = ref[0], setSelectedCategoryId = ref[1];
    var ref1 = (0,react.useState)([]), selectedProducts = ref1[0], setSelectedProducts = ref1[1];
    var ref2 = (0,react.useState)([]), selectedCategoryName = ref2[0], setSelectedCategoryName = ref2[1];
    var previousCategoryIdRef = (0,react.useRef)(null);
    var ref3 = (0,additional_order/* useRecommendedPharmacyAdditionalOrderProducts */.Sz)(String(diagnosisId), String(pharmacyId)), recommendedAdditionalOrderProducts = ref3.recommendedAdditionalOrderProducts, recommendedDescription = ref3.recommendedDescription, isRecommendedAdditionalOrderProductLoading = ref3.isRecommendedAdditionalOrderProductLoading;
    var additionalOrderCategories = (0,additional_order/* usePharmacyAdditionalOrderCategories */.z1)().additionalOrderCategories;
    var isRecommendedCategorySelected = selectedCategoryId === null && recommendedAdditionalOrderProducts.length > 0;
    var ref4 = (0,additional_order/* usePharmacyAdditionalOrderProductsByPharmacyIdAndCategoryIdInfinite */.$V)({
        pharmacyId: String(pharmacyId),
        categoryId: selectedCategoryId
    }, !isRecommendedCategorySelected), additionalOrderProducts = ref4.additionalOrderProducts, isLoadingAdditionalOrderProducts = ref4.isLoadingAdditionalOrderProducts, fetchNextPageAdditionalOrderProducts = ref4.fetchNextPageAdditionalOrderProducts, hasNextPageAdditionalOrderProducts = ref4.hasNextPageAdditionalOrderProducts;
    /* 연관상품 유무에 따른 카테고리 노출 변경 */ var additionalOrderCategoryList = (0,react.useMemo)(function() {
        if (recommendedAdditionalOrderProducts.length > 0) {
            var ref;
            return (ref = additionalOrderCategories === null || additionalOrderCategories === void 0 ? void 0 : additionalOrderCategories.getCategoriesWithRecommended()) !== null && ref !== void 0 ? ref : [];
        }
        var ref1;
        return (ref1 = additionalOrderCategories === null || additionalOrderCategories === void 0 ? void 0 : additionalOrderCategories.getCategoriesWithAll()) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        recommendedAdditionalOrderProducts,
        additionalOrderCategories
    ]);
    /* 연관 상품 유무에 따른 프로덕트 참조값 변경 */ var products = (0,react.useMemo)(function() {
        if (selectedCategoryId === null && recommendedAdditionalOrderProducts.length > 0) {
            return recommendedAdditionalOrderProducts;
        }
        return additionalOrderProducts;
    }, [
        recommendedAdditionalOrderProducts,
        additionalOrderProducts,
        selectedCategoryId
    ]);
    var requestPartnershipPickupDispensationMutation = (0,order/* useRequestPartnershipPickupDispensation */.R)().requestPartnershipPickupDispensationMutation;
    var onSetSelectedCategoryName = function(categoryName) {
        if (selectedCategoryName.includes(categoryName)) {
            return;
        }
        setSelectedCategoryName(function(prev) {
            return (0,_to_consumable_array/* default */.Z)(prev).concat([
                categoryName
            ]);
        });
    };
    var onLogSelectedCategoriesName = function() {
        var ref;
        log({
            eventName: ORDER_LOG_EVENT.CLICKED_ADDITIONAL_ORDER_CATEGORIES,
            payload: {
                categoryName: selectedCategoryName.join(","),
                productsCount: (ref = additionalOrderProducts === null || additionalOrderProducts === void 0 ? void 0 : additionalOrderProducts.length) !== null && ref !== void 0 ? ref : 0,
                pharmacyId: String(pharmacyId),
                diagnosisId: String(diagnosisId)
            }
        });
    };
    var onClickCategoryTab = function(category) {
        var _id, _current;
        log({
            eventName: ORDER_LOG_EVENT.CLICKED_ADDITIONAL_ORDER_CATEGORY_TAB,
            payload: {
                categoryId: (_id = category.id) !== null && _id !== void 0 ? _id : "",
                categoryName: category.name,
                previousCategoryId: (_current = previousCategoryIdRef.current) !== null && _current !== void 0 ? _current : "",
                pharmacyId: String(pharmacyId),
                diagnosisId: String(diagnosisId)
            }
        });
        previousCategoryIdRef.current = category.id;
        setSelectedCategoryId(category.id);
        onSetSelectedCategoryName(category.name);
    };
    var getIsSelectedProduct = function(product) {
        return selectedProducts.some(function(p) {
            return p.id === product.id;
        });
    };
    var getSelectedProductCount = function(product) {
        var ref;
        var ref1;
        return (ref1 = (ref = selectedProducts.find(function(p) {
            return p.id === product.id;
        })) === null || ref === void 0 ? void 0 : ref.quantity) !== null && ref1 !== void 0 ? ref1 : 0;
    };
    var onAddProductToCart = function(product) {
        var currentQuantity = getSelectedProductCount(product);
        var isNewProduct = !getIsSelectedProduct(product);
        var newQuantity = isNewProduct ? 1 : currentQuantity + 1;
        log({
            eventName: ORDER_LOG_EVENT.CLICKED_ADDITIONAL_ORDER_ADD_TO_CART,
            payload: {
                productId: product.id,
                productName: product.name,
                categoryId: product.categoryId,
                price: product.price,
                quantity: newQuantity,
                totalSelectedCount: isNewProduct ? selectedProducts.length + 1 : selectedProducts.length,
                pharmacyId: String(pharmacyId),
                diagnosisId: String(diagnosisId)
            }
        });
        if (isNewProduct) {
            setSelectedProducts(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, product), {
                        quantity: newQuantity
                    })
                ]);
            });
            return;
        }
        if (currentQuantity < MAX_ADD_PRODUCT_QUANTITY) {
            setSelectedProducts(function(prev) {
                return prev.map(function(p) {
                    return p.id === product.id ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                        quantity: newQuantity
                    }) : p;
                });
            });
        }
    };
    var onRemoveProductFromCart = function(product) {
        var currentQuantity = getSelectedProductCount(product);
        var newQuantity = currentQuantity - 1;
        var willRemove = currentQuantity === 1;
        log({
            eventName: ORDER_LOG_EVENT.CLICKED_ADDITIONAL_ORDER_REMOVE_FROM_CART,
            payload: {
                productId: product.id,
                productName: product.name,
                categoryId: product.categoryId,
                price: product.price,
                quantity: Math.max(0, newQuantity),
                totalSelectedCount: willRemove ? selectedProducts.length - 1 : selectedProducts.length,
                pharmacyId: String(pharmacyId),
                diagnosisId: String(diagnosisId)
            }
        });
        setSelectedProducts(function(prev) {
            if (getIsSelectedProduct(product) && currentQuantity > 1) {
                return prev.map(function(p) {
                    return p.id === product.id ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                        quantity: newQuantity
                    }) : p;
                });
            } else if (willRemove) {
                return prev.filter(function(p) {
                    return p.id !== product.id;
                });
            }
            return prev;
        });
    };
    var onSkipToAdditionalOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        log({
                            eventName: ORDER_LOG_EVENT.CLICKED_SKIP_ADDITIONAL_ORDER,
                            payload: {
                                productsCount: (ref = additionalOrderProducts === null || additionalOrderProducts === void 0 ? void 0 : additionalOrderProducts.length) !== null && ref !== void 0 ? ref : 0,
                                pharmacyId: String(pharmacyId),
                                diagnosisId: String(diagnosisId)
                            }
                        });
                        onLogSelectedCategoriesName();
                        setSelectedProducts([]);
                        return [
                            4,
                            onSubmitOrder([])
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSkipToAdditionalOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var getUserLocationPosition = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var location, permission, position, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        location = {
                            longitude: 0,
                            latitude: 0
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            postMessageEventList_messages/* nativePostMessageEventList.checkLocationPermission */.n.checkLocationPermission()
                        ];
                    case 2:
                        permission = _state.sent();
                        if (!permission) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            postMessageEventList_messages/* nativePostMessageEventList.getLocationPosition */.n.getLocationPosition()
                        ];
                    case 3:
                        position = _state.sent();
                        location = (0,_object_spread/* default */.Z)({}, position);
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            location
                        ];
                    case 5:
                        e = _state.sent();
                        (0,report/* warningReport */.jg)("약국 처방전 전송 페이지에서 위치정보를 가져오는데 실패했습니다.", {});
                        return [
                            2,
                            location
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function getUserLocationPosition() {
            return _ref.apply(this, arguments);
        };
    }();
    var onRequestPartnershipPickupDispensation = (0,react.useCallback)(debounce_default()(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(props) {
            var receiptLocation;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getUserLocationPosition()
                        ];
                    case 1:
                        receiptLocation = _state.sent();
                        requestPartnershipPickupDispensationMutation({
                            request: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                pharmacyId: String(props.pharmacyId),
                                diagnosisId: String(props.diagnosisId),
                                mainTagTypes: JSON.parse(props.mainTagTypes)
                            }, props.isUserAlternativeSelected !== null && {
                                isUserAlternativeSelected: props.isUserAlternativeSelected === "true" ? true : false
                            }), {
                                medicineRequestInfos: JSON.parse(props.medicineRequestInfos),
                                receiptLocation: receiptLocation,
                                additionalProducts: !!props.products.length ? props.products.map(function(product) {
                                    return {
                                        productId: product.id,
                                        quantity: product.quantity
                                    };
                                }) : []
                            })
                        }, {
                            onSuccess: function() {
                                navigate.navigateToSelectedScreenWithResetNavigation({
                                    screenName: common/* ROUTES.DIAGNOSIS.DETAIL.appScreenName */.Z6.DIAGNOSIS.DETAIL.appScreenName
                                });
                            },
                            onError: function() {
                                showModal({
                                    type: modal/* MODAL_TYPE.ALERT */.f.ALERT,
                                    props: {
                                        title: "약국에서 처방전을 받을 수 없어요.",
                                        message: "다른 약국을 선택해주세요.",
                                        buttons: [
                                            {
                                                type: modal/* MODAL_BUTTON_TYPE.PRIMARY */.J.PRIMARY,
                                                label: "약국 재선택",
                                                onClick: RNPlugins/* historyBack */.$i
                                            }, 
                                        ]
                                    }
                                });
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }(), DEBOUNCE_TIME, {
        leading: true,
        trailing: false
    }), []);
    var onMovePaymentScreen = function(products) {
        navigate.navigateToPaymentScreen({
            price: Number(amountToPay),
            immediatePayOrderInfoV2: (0,_object_spread/* default */.Z)({
                diagnosisId: String(diagnosisId),
                pharmacyId: String(pharmacyId),
                amountToPay: Number(amountToPay),
                medicinePriceInfos: JSON.parse(medicineRequestInfos),
                deliveryCategoryType: pharmacy/* EDeliveryCategoryType.Partnership_pickup */.xH.Partnership_pickup,
                mainTagTypes: JSON.parse(mainTagTypes).join(",")
            }, isUserAlternativeSelected !== null && {
                isUserAlternativeSelected: isUserAlternativeSelected === "true" ? true : false
            }),
            additionalOrderProducts: {
                additionalProducts: products.length ? products.map(function(product) {
                    return {
                        productId: product.id,
                        quantity: product.quantity,
                        price: product.price,
                        name: product.name
                    };
                }) : [],
                additionalOrderAmountToPay: products.length ? products.reduce(function(acc, product) {
                    return acc + product.price * product.quantity;
                }, 0) : null
            }
        });
    };
    var onSubmitOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(products) {
            var additionalProducts;
            return (0,tslib_es6.__generator)(this, function(_state) {
                onLogSelectedCategoriesName();
                additionalProducts = products !== null && products !== void 0 ? products : selectedProducts;
                log({
                    eventName: ORDER_LOG_EVENT.CLICKED_SUBMIT_ADDITIONAL_ORDER,
                    payload: {
                        productCount: additionalProducts.length,
                        totalAmount: additionalProducts.reduce(function(acc, product) {
                            return acc + product.price * product.quantity;
                        }, 0),
                        productIds: additionalProducts.map(function(p) {
                            return p.id;
                        }).join(","),
                        pharmacyId: String(pharmacyId),
                        diagnosisId: String(diagnosisId)
                    }
                });
                if (prescriptionSendType === pharmacy/* EPrescriptionSendType.ImmediatePaymentPartnership */.aV.ImmediatePaymentPartnership) {
                    onMovePaymentScreen(additionalProducts);
                    return [
                        2
                    ];
                }
                onRequestPartnershipPickupDispensation({
                    products: additionalProducts,
                    pharmacyId: String(pharmacyId),
                    diagnosisId: String(diagnosisId),
                    mainTagTypes: String(mainTagTypes),
                    isUserAlternativeSelected: isUserAlternativeSelected !== null ? String(isUserAlternativeSelected) : null,
                    medicineRequestInfos: String(medicineRequestInfos)
                });
                return [
                    2
                ];
            });
        });
        return function onSubmitOrder(products) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var enterTime = Date.now();
        return function() {
            var exitTime = Date.now();
            var dwellTimeInSeconds = Math.round((exitTime - enterTime) / 1000);
            log({
                eventName: ORDER_LOG_EVENT.EXITED_ADDITIONAL_ORDER_PAGE,
                payload: {
                    dwellTime: dwellTimeInSeconds,
                    pharmacyId: String(pharmacyId),
                    diagnosisId: String(diagnosisId)
                }
            });
        };
    }, []);
    return {
        recommendedDescription: recommendedDescription,
        isRecommendedAdditionalOrderProductLoading: isRecommendedAdditionalOrderProductLoading,
        additionalOrderCategories: additionalOrderCategoryList,
        isLoadingAdditionalOrderProducts: isLoadingAdditionalOrderProducts,
        hasNextPageAdditionalOrderProducts: hasNextPageAdditionalOrderProducts,
        selectedCategoryId: selectedCategoryId,
        additionalOrderProducts: products,
        selectedProducts: selectedProducts,
        fetchNextPageAdditionalOrderProducts: fetchNextPageAdditionalOrderProducts,
        onClickCategoryTab: onClickCategoryTab,
        getIsSelectedProduct: getIsSelectedProduct,
        onAddProductToCart: onAddProductToCart,
        onRemoveProductFromCart: onRemoveProductFromCart,
        getSelectedProductCount: getSelectedProductCount,
        onSkipToAdditionalOrder: onSkipToAdditionalOrder,
        onSubmitOrder: onSubmitOrder
    };
};
/* harmony default export */ var AdditionalOrderViewModel = (useAdditionalOrderViewModel);

;// CONCATENATED MODULE: ./src/views/additional-order/index.ts




// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./src/components/common/ImpressionLogger.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var listViewStartedAt = new Date().getTime();
var ImpressionLogger = function(props) {
    var _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var logger = (0,useLogger/* default */.Z)();
    var shouldLog = (0,react.useRef)(true);
    var itemRef = (0,react.useRef)(null);
    var setLoggingEnabled = function() {
        shouldLog.current = true;
    };
    var setLoggingDisabled = function() {
        shouldLog.current = false;
    };
    var logging = function() {
        logger.log({
            eventName: props.params.eventName,
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.params.payload), {
                listViewStartedAt: listViewStartedAt
            })
        });
    };
    (0,react.useEffect)(function() {
        if (!enabled) {
            return;
        }
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (!entry.isIntersecting) {
                    return;
                }
                if (!shouldLog.current) {
                    return;
                }
                setLoggingDisabled();
                logging();
            });
        });
        if (itemRef.current) {
            observer.observe(itemRef.current);
        }
        return function() {
            if (itemRef.current) {
                observer.unobserve(itemRef.current);
            }
        };
    }, [
        enabled
    ]);
    (0,react.useEffect)(function() {
        setLoggingEnabled();
        listViewStartedAt = new Date().getTime();
        return function() {
            setLoggingDisabled();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        ref: itemRef,
        children: props.children
    });
};
/* harmony default export */ var common_ImpressionLogger = (ImpressionLogger);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1376f8bd-0"
})(_templateObject());

// EXTERNAL MODULE: ./src/components/common/infinite-scroll/index.tsx + 1 modules
var infinite_scroll = __webpack_require__(39219);
// EXTERNAL MODULE: ./src/components/atom/MaterialIcon.tsx
var MaterialIcon = __webpack_require__(17986);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(44376);
;// CONCATENATED MODULE: ./src/views/additional-order/ui/AdditionalOrderProductItem.tsx






var AdditionalOrderProductItem = function(props) {
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var ref1 = (0,react.useState)(false), hasOverflow = ref1[0], setHasOverflow = ref1[1];
    var descriptionRef = (0,react.useRef)(null);
    var hasDescription = props.product.description.trim().length > 0;
    (0,react.useEffect)(function() {
        if (!hasDescription || !descriptionRef.current) {
            setHasOverflow(false);
            return;
        }
        var checkOverflow = function() {
            var element = descriptionRef.current;
            if (element) {
                var isOverflowing = element.scrollHeight > element.clientHeight;
                setHasOverflow(isOverflowing);
            }
        };
        checkOverflow();
        // 윈도우 리사이즈 시에도 체크
        window.addEventListener("resize", checkOverflow);
        return function() {
            return window.removeEventListener("resize", checkOverflow);
        };
    }, [
        hasDescription,
        props.product.description
    ]);
    var toggleDescription = function() {
        setIsExpanded(function(prev) {
            return !prev;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center gap-[16px] p-[12px_24px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-[80px] w-[80px] shrink-0 items-center justify-center overflow-hidden rounded-[7px] bg-gray-30",
                children: props.product.imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: props.product.imageUrl,
                    alt: props.product.name,
                    className: "h-full w-full object-cover"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                    name: "healing",
                    size: 36,
                    color: theme/* default.color.gray200 */.Z.color.gray200,
                    filled: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex min-w-0 flex-1 flex-col gap-[8px] py-[4px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[2px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "typography-ui-15m text-gray-700",
                                children: props.product.name
                            }),
                            hasDescription && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        ref: descriptionRef,
                                        className: "typography-ui-12r text-gray-400 ".concat(!isExpanded ? "line-clamp-2" : ""),
                                        children: props.product.description
                                    }),
                                    hasOverflow && !isExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "typography-ui-12r cursor-pointer text-gray-400 underline",
                                        onClick: toggleDescription,
                                        children: "더보기"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "typography-ui-15sb text-gray-800",
                        children: props.product.getDisplayPrice()
                    })
                ]
            }),
            props.isSelected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex h-[32px] w-[72px] shrink-0 items-center justify-center rounded-[8px] border border-primary-600 border-solid",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex h-full items-center px-[6px] py-[8px]",
                        onClick: function() {
                            return props.onRemoveProductFromCart(props.product);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "remove",
                            size: 16,
                            color: theme/* default.color.gray700 */.Z.color.gray700
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "typography-ui-15sb w-[24px] text-center text-gray-700",
                        children: props.selectedCount
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex h-full items-center px-[6px] py-[8px]",
                        onClick: function() {
                            return props.onAddProductToCart(props.product);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                            name: "add",
                            size: 16,
                            color: props.selectedCount === MAX_ADD_PRODUCT_QUANTITY ? theme/* default.color.gray100 */.Z.color.gray100 : theme/* default.color.gray700 */.Z.color.gray700
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                size: "s",
                buttonColor: "gray",
                buttonStyle: "contained",
                onClick: function() {
                    return props.onAddProductToCart(props.product);
                },
                className: "h-[32px] w-[72px] shrink-0",
                children: "담기"
            })
        ]
    });
};
/* harmony default export */ var ui_AdditionalOrderProductItem = (AdditionalOrderProductItem);

;// CONCATENATED MODULE: ./src/views/additional-order/ui/EmptyAdditionOrderProducts.tsx



var EmptyAdditionOrderProducts = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex h-[436px] flex-col items-center justify-center gap-[16px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col items-center justify-center gap-[16px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcon/* default */.Z, {
                    name: "upcoming",
                    size: 48,
                    color: theme/* default.color.gray100 */.Z.color.gray100,
                    filled: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "typography-ui-15m text-gray-400",
                    children: "상품을 준비하고 있어요"
                })
            ]
        })
    });
};
/* harmony default export */ var ui_EmptyAdditionOrderProducts = (EmptyAdditionOrderProducts);

;// CONCATENATED MODULE: ./src/views/additional-order/ui/AdditionalOrderProducts.tsx







var AdditionalOrderProducts = function(props) {
    var router = (0,next_router.useRouter)();
    var _query = router.query, pharmacyId = _query.pharmacyId, diagnosisId = _query.diagnosisId;
    if (!props.additionalOrderProducts) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (props.additionalOrderProducts.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_EmptyAdditionOrderProducts, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(infinite_scroll/* default */.Z, {
        rootMargin: "0px 0px 0px 100px",
        isLoading: props.isLoadingAdditionalOrderProducts,
        hasNextPage: props.hasNextPageAdditionalOrderProducts,
        fetchNextPage: props.fetchNextPageAdditionalOrderProducts,
        children: props.additionalOrderProducts.map(function(product, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(common_ImpressionLogger, {
                enabled: true,
                params: {
                    eventName: ORDER_LOG_EVENT.IMPRESSED_ADDITIONAL_ORDER_PRODUCT,
                    payload: {
                        productId: product.id,
                        productName: product.name,
                        categoryId: product.categoryId,
                        price: product.price,
                        position: index,
                        pharmacyId: String(pharmacyId),
                        diagnosisId: String(diagnosisId)
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_AdditionalOrderProductItem, {
                    product: product,
                    isSelected: props.getIsSelectedProduct(product),
                    selectedCount: props.getSelectedProductCount(product),
                    onAddProductToCart: props.onAddProductToCart,
                    onRemoveProductFromCart: props.onRemoveProductFromCart
                })
            }, product.id);
        })
    });
};
/* harmony default export */ var ui_AdditionalOrderProducts = (AdditionalOrderProducts);

;// CONCATENATED MODULE: ./src/views/additional-order/ui/AdditionalOrderView.tsx







var AdditionalOrderView = function() {
    var viewModel = AdditionalOrderViewModel();
    if (!viewModel.additionalOrderCategories || viewModel.isRecommendedAdditionalOrderProductLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Wrapper */.Z.Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TemplateLayout/* default.StickyHeader */.Z.StickyHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sticky_app_header/* default */.Z, {
                    left: true,
                    etcButton: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "typography-ui-15m cursor-pointer text-gray-600",
                        onClick: viewModel.onSkipToAdditionalOrder,
                        children: "괜찮아요"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TemplateLayout/* default.Content */.Z.Content, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[24px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col gap-[8px] p-[12px_24px_0]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "typography-ui-24sb whitespace-pre-wrap text-gray-900",
                                    children: viewModel.recommendedDescription
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-[80px] flex flex-col gap-[12px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dnslide_tab/* default */.Z, {
                                        value: viewModel.selectedCategoryId,
                                        children: viewModel.additionalOrderCategories.map(function(tab) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dnslide_tab/* default.Item */.Z.Item, {
                                                label: tab.name,
                                                isActive: tab.id === viewModel.selectedCategoryId,
                                                onClick: function() {
                                                    return viewModel.onClickCategoryTab(tab);
                                                }
                                            }, tab.id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_AdditionalOrderProducts, {
                                        additionalOrderProducts: viewModel.additionalOrderProducts,
                                        isLoadingAdditionalOrderProducts: viewModel.isLoadingAdditionalOrderProducts,
                                        hasNextPageAdditionalOrderProducts: viewModel.hasNextPageAdditionalOrderProducts,
                                        fetchNextPageAdditionalOrderProducts: viewModel.fetchNextPageAdditionalOrderProducts,
                                        getIsSelectedProduct: viewModel.getIsSelectedProduct,
                                        getSelectedProductCount: viewModel.getSelectedProductCount,
                                        onAddProductToCart: viewModel.onAddProductToCart,
                                        onRemoveProductFromCart: viewModel.onRemoveProductFromCart
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "fixed right-0 bottom-0 left-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[24px] bg-gradient-to-b from-white/0 to-white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center justify-between bg-white px-[24px] pb-[16px]",
                                children: viewModel.selectedProducts.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Button */.zx, {
                                    size: "xl",
                                    buttonColor: "primary",
                                    className: "w-full",
                                    onClick: viewModel.onSubmitOrder,
                                    children: [
                                        viewModel.selectedProducts.length,
                                        "개 상품 함께 구매"
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                    size: "xl",
                                    buttonColor: "gray",
                                    buttonStyle: "outlined",
                                    className: "w-full",
                                    onClick: viewModel.onSkipToAdditionalOrder,
                                    children: "추가 구매 없이 계속하기"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ui_AdditionalOrderView = (AdditionalOrderView);

;// CONCATENATED MODULE: ./src/pages/additional-order/index.tsx
// PageDescription: 추가 주문 페이지



var AdditionalOrderPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_AdditionalOrderView, {});
};
AdditionalOrderPage.Layout = DefaultLayout/* default */.Z;
/* harmony default export */ var pages_additional_order = (AdditionalOrderPage);


/***/ }),

/***/ 6271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ EPharmacyViewType; },
/* harmony export */   "LR": function() { return /* binding */ EPharmacyFilterMode; },
/* harmony export */   "Ns": function() { return /* binding */ EPharmacyReviewStatus; },
/* harmony export */   "Vc": function() { return /* binding */ PharmacySearchParamsQueries; },
/* harmony export */   "aT": function() { return /* binding */ ENearbyPharmacySearchFilterType; },
/* harmony export */   "aV": function() { return /* binding */ EPrescriptionSendType; },
/* harmony export */   "r1": function() { return /* binding */ EPharmacyFilterStatus; },
/* harmony export */   "ru": function() { return /* binding */ EAlternativeType; },
/* harmony export */   "sZ": function() { return /* binding */ ENearbyPharmacySearchSortType; },
/* harmony export */   "sh": function() { return /* binding */ EPharmacyOperationType; },
/* harmony export */   "xH": function() { return /* binding */ EDeliveryCategoryType; }
/* harmony export */ });
/* unused harmony export EPharmacyTagType */
var PharmacySearchParamsQueries;
(function(PharmacySearchParamsQueries) {
    PharmacySearchParamsQueries["SortType"] = "sortType";
    PharmacySearchParamsQueries["CommonFilter"] = "commonFilter";
    PharmacySearchParamsQueries["NorthEastLatitude"] = "northEastLatitude";
    PharmacySearchParamsQueries["NorthEastLongitude"] = "northEastLongitude";
    PharmacySearchParamsQueries["SouthWestLatitude"] = "southWestLatitude";
    PharmacySearchParamsQueries["SouthWestLongitude"] = "southWestLongitude";
    PharmacySearchParamsQueries["Latitude"] = "latitude";
    PharmacySearchParamsQueries["Longitude"] = "longitude";
    PharmacySearchParamsQueries["ViewType"] = "viewType";
    PharmacySearchParamsQueries["DiagnosisTypeId"] = "diagnosisTypeId";
    PharmacySearchParamsQueries["TreatmentMedicineId"] = "treatmentMedicineId";
    PharmacySearchParamsQueries["TreatmentMedicineUnitId"] = "treatmentMedicineUnitId";
    PharmacySearchParamsQueries["TreatmentMedicineStrengthId"] = "treatmentMedicineStrengthId";
})(PharmacySearchParamsQueries || (PharmacySearchParamsQueries = {}));
var EPharmacyViewType;
(function(EPharmacyViewType) {
    EPharmacyViewType["Map"] = "map";
    EPharmacyViewType["List"] = "list";
})(EPharmacyViewType || (EPharmacyViewType = {}));
var EPharmacyOperationType;
(function(EPharmacyOperationType) {
    EPharmacyOperationType["BeforeOpen"] = "BeforeOpen";
    EPharmacyOperationType["Open"] = "Open";
    EPharmacyOperationType["Closed"] = "Closed";
    EPharmacyOperationType["Lunch"] = "Lunch";
    EPharmacyOperationType["DayOff"] = "DayOff";
    EPharmacyOperationType["BreakTime"] = "BreakTime";
    EPharmacyOperationType["Unknown"] = "Unknown";
    EPharmacyOperationType["ClosedSoon"] = "ClosedSoon";
    EPharmacyOperationType["Absent"] = "Absent";
})(EPharmacyOperationType || (EPharmacyOperationType = {}));
var EPrescriptionSendType;
(function(EPrescriptionSendType) {
    EPrescriptionSendType["Call"] = "CALL";
    EPrescriptionSendType["SendPrescriptionPartnership"] = "SEND_PRESCRIPTION_PARTNERSHIP";
    EPrescriptionSendType["ClosedPharmacy"] = "CLOSED_PHARMACY";
    EPrescriptionSendType["PrescriptionBookingPartnership"] = "PRESCRIPTION_BOOKING_PARTNERSHIP";
    EPrescriptionSendType["PrescriptionDeniedPharmacy"] = "PRESCRIPTION_DENIED_PHARMACY";
    EPrescriptionSendType["ImmediatePaymentPartnership"] = "IMMEDIATE_PAYMENT_PARTNERSHIP";
    EPrescriptionSendType["SendPrescriptionNowPartnership"] = "SEND_PRESCRIPTION_NOW_PARTNERSHIP";
})(EPrescriptionSendType || (EPrescriptionSendType = {}));
var EPharmacyTagType;
(function(EPharmacyTagType) {
    EPharmacyTagType["PRESCRIPTION_MEDICINE_AVAILABLE"] = "PRESCRIPTION_MEDICINE_AVAILABLE";
    EPharmacyTagType["PRESCRIPTION_REJECT"] = "PRESCRIPTION_REJECT";
    EPharmacyTagType["NORMAL"] = "NORMAL";
    EPharmacyTagType["REQUIRED_CALL"] = "REQUIRED_CALL";
    EPharmacyTagType["DIET_INJECTION"] = "DIET_INJECTION";
    EPharmacyTagType["IN_STOCK"] = "IN_STOCK";
})(EPharmacyTagType || (EPharmacyTagType = {}));
var EPharmacyReviewStatus;
(function(EPharmacyReviewStatus) {
    EPharmacyReviewStatus["RECEIPT_UPLOAD"] = "RECEIPT_UPLOAD";
    EPharmacyReviewStatus["RECEIPT_RECOGNITION_FAILED"] = "RECEIPT_RECOGNITION_FAILED";
    EPharmacyReviewStatus["CONFIRM_SAME_PHARMACY_INFORMATION"] = "CONFIRM_SAME_PHARMACY_INFORMATION";
    EPharmacyReviewStatus["DIFFERENT_PHARMACY_INFORMATION"] = "DIFFERENT_PHARMACY_INFORMATION";
    EPharmacyReviewStatus["INPUT_PHARMACY_NAME"] = "INPUT_PHARMACY_NAME";
    EPharmacyReviewStatus["CONFIRM_DIFFERENT_PHARMACY_INFORMATION"] = "CONFIRM_DIFFERENT_PHARMACY_INFORMATION";
    EPharmacyReviewStatus["SUBMIT_PHARMACY_REVIEW_INFORMATION"] = "SUBMIT_PHARMACY_REVIEW_INFORMATION";
})(EPharmacyReviewStatus || (EPharmacyReviewStatus = {}));
var ENearbyPharmacySearchFilterType;
(function(ENearbyPharmacySearchFilterType) {
    ENearbyPharmacySearchFilterType["CheapPrice"] = "CHEAP_PRICE";
    ENearbyPharmacySearchFilterType["HandlingMedicine"] = "HANDLING_MEDICINE";
    ENearbyPharmacySearchFilterType["IsOpenAtLateNight"] = "IS_OPEN_AT_LATE_NIGHT";
    ENearbyPharmacySearchFilterType["IsOpenEveryDay"] = "IS_OPEN_EVERY_DAY";
    ENearbyPharmacySearchFilterType["Operating"] = "OPERATING";
    ENearbyPharmacySearchFilterType["IncludeDiagnosisPrice"] = "INCLUDE_DIAGNOSIS_PRICE";
    ENearbyPharmacySearchFilterType["ImmediatePayment"] = "IMMEDIATE_PAYMENT";
    ENearbyPharmacySearchFilterType["RequestWithApp"] = "REQUEST_WITH_APP";
    ENearbyPharmacySearchFilterType["DispensationProbability"] = "DISPENSATION_PROBABILITY";
    ENearbyPharmacySearchFilterType["SameMedicine"] = "SAME_MEDICINE";
    ENearbyPharmacySearchFilterType["ConfirmedDispensation"] = "CONFIRMED_DISPENSATION";
    ENearbyPharmacySearchFilterType["HighDispensationProbability"] = "HIGH_DISPENSATION_PROBABILITY";
    ENearbyPharmacySearchFilterType["PossibleDispensation"] = "POSSIBLE_DISPENSATION";
    ENearbyPharmacySearchFilterType["Now"] = "NOW";
})(ENearbyPharmacySearchFilterType || (ENearbyPharmacySearchFilterType = {}));
var ENearbyPharmacySearchSortType;
(function(ENearbyPharmacySearchSortType) {
    ENearbyPharmacySearchSortType["Distance"] = "DISTANCE";
    ENearbyPharmacySearchSortType["LowPrice"] = "LOW_PRICE";
    ENearbyPharmacySearchSortType["QuickReceipt"] = "QUICK_RECEIPT";
    ENearbyPharmacySearchSortType["VisitCount"] = "VISIT_COUNT";
    ENearbyPharmacySearchSortType["MostReviews"] = "MOST_REVIEWS";
    ENearbyPharmacySearchSortType["HighRating"] = "HIGH_RATING";
})(ENearbyPharmacySearchSortType || (ENearbyPharmacySearchSortType = {}));
var EPharmacyFilterMode;
(function(EPharmacyFilterMode) {
    EPharmacyFilterMode["List"] = "LIST";
    EPharmacyFilterMode["Toggle"] = "TOGGLE";
    EPharmacyFilterMode["Range"] = "RANGE";
})(EPharmacyFilterMode || (EPharmacyFilterMode = {}));
var EPharmacyFilterStatus;
(function(EPharmacyFilterStatus) {
    EPharmacyFilterStatus["Selected"] = "SELECTED";
    EPharmacyFilterStatus["Unselected"] = "UNSELECTED";
    EPharmacyFilterStatus["SubFilterSelected"] = "SUB_FILTER_SELECTED";
    EPharmacyFilterStatus["SubFilterUnselected"] = "SUB_FILTER_UNSELECTED";
})(EPharmacyFilterStatus || (EPharmacyFilterStatus = {}));
var EDeliveryCategoryType;
(function(EDeliveryCategoryType) {
    EDeliveryCategoryType["Pickup"] = "PICKUP";
    EDeliveryCategoryType["Post"] = "POST";
    EDeliveryCategoryType["Quick"] = "QUICK";
    EDeliveryCategoryType["Today_Delivery"] = "TODAY_DELIVERY";
    EDeliveryCategoryType["Dawn"] = "DAWN";
    EDeliveryCategoryType["Partnership_pickup"] = "PARTNERSHIP_PICKUP";
})(EDeliveryCategoryType || (EDeliveryCategoryType = {}));
var EAlternativeType;
(function(EAlternativeType) {
    EAlternativeType["Alternative"] = "ALTERNATIVE";
    EAlternativeType["SameMedicine"] = "SAME_MEDICINE";
})(EAlternativeType || (EAlternativeType = {}));


/***/ }),

/***/ 76666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ cn; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40489);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98388);


function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}


/***/ }),

/***/ 83464:
/***/ (function(module) {

"use strict";
module.exports = cacheable-lookup;

/***/ }),

/***/ 59403:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ useInfiniteQuery; }
});

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/queryObserver.mjs
var queryObserver = __webpack_require__(52924);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(9499);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/infiniteQueryObserver.mjs



class InfiniteQueryObserver extends queryObserver/* QueryObserver */.z {
  // Type override
  // Type override
  // Type override
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(client, options) {
    super(client, options);
  }

  bindMethods() {
    super.bindMethods();
    this.fetchNextPage = this.fetchNextPage.bind(this);
    this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
  }

  setOptions(options, notifyOptions) {
    super.setOptions({ ...options,
      behavior: (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)()
    }, notifyOptions);
  }

  getOptimisticResult(options) {
    options.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return super.getOptimisticResult(options);
  }

  fetchNextPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'forward',
          pageParam
        }
      }
    });
  }

  fetchPreviousPage({
    pageParam,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        fetchMore: {
          direction: 'backward',
          pageParam
        }
      }
    });
  }

  createResult(query, options) {
    var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;

    const {
      state
    } = query;
    const result = super.createResult(query, options);
    const {
      isFetching,
      isRefetching
    } = result;
    const isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === 'forward';
    const isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === 'backward';
    return { ...result,
      fetchNextPage: this.fetchNextPage,
      fetchPreviousPage: this.fetchPreviousPage,
      hasNextPage: (0,infiniteQueryBehavior/* hasNextPage */.Qy)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
      hasPreviousPage: (0,infiniteQueryBehavior/* hasPreviousPage */.ZF)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
      isFetchingNextPage,
      isFetchingPreviousPage,
      isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
    };
  }

}


//# sourceMappingURL=infiniteQueryObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs + 3 modules
var useBaseQuery = __webpack_require__(36661);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useInfiniteQuery.mjs



function useInfiniteQuery(arg1, arg2, arg3) {
  const options = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return (0,useBaseQuery/* useBaseQuery */.r)(options, InfiniteQueryObserver);
}


//# sourceMappingURL=useInfiniteQuery.mjs.map


/***/ }),

/***/ 48228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var mutation = __webpack_require__(89886);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationObserver.mjs





// CLASS
class MutationObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.setOptions(options);
    this.bindMethods();
    this.updateResult();
  }

  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }

  setOptions(options) {
    const prevOptions = this.options;
    this.options = this.client.defaultMutationOptions(options);

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getMutationCache().notify({
        type: 'observerOptionsUpdated',
        mutation: this.currentMutation,
        observer: this
      });
    }
  }

  onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation;

      (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.removeObserver(this);
    }
  }

  onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    const notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  }

  mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, { ...this.options,
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    });
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  }

  updateResult() {
    const state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();
    const result = { ...state,
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = result;
  }

  notify(options) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the mutate callbacks
      if (this.mutateOptions) {
        if (options.onSuccess) {
          var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;

          (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null ? void 0 : _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (options.onError) {
          var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;

          (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null ? void 0 : _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        this.listeners.forEach(listener => {
          listener(this.currentResult);
        });
      }
    });
  }

}


//# sourceMappingURL=mutationObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(24798);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs






function useMutation(arg1, arg2, arg3) {
  const options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const [observer] = react.useState(() => new MutationObserver(queryClient, options));
  react.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result = (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  const mutate = react.useCallback((variables, mutateOptions) => {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);

  if (result.error && (0,lib_utils/* shouldThrowError */.L)(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }

  return { ...result,
    mutate,
    mutateAsync: result.mutate
  };
} // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}


//# sourceMappingURL=useMutation.mjs.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,6492,1498,8391,9653,5180,8995,9774,2888,179], function() { return __webpack_exec__(83336); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);